import { useTranslation as useI18nTranslation } from "react-i18next";
import { defaultNS, Namespace } from "../config";
import i18n from "i18next";

export const useTranslation = (ns?: Namespace) => {
  return useI18nTranslation(ns || defaultNS);
};

export const useCommonTranslation = () => {
  return useTranslation("common");
};

export const useLandingTranslation = () => {
  return useTranslation("landing");
};

export const useAboutTranslation = () => {
  return useTranslation("about");
};

export const useLegalTranslation = () => {
  return useTranslation("legal");
};

// Helper function to check if translations are loaded for a namespace
export const isTranslationLoaded = (
  language: string,
  namespace: string
): boolean => {
  return i18n.hasResourceBundle(language, namespace);
};

// Helper function to ensure components show proper translations even during initial render
export const ensureTranslationsLoaded = async (
  lng: string = i18n.language,
  namespaces: string[] = [defaultNS]
): Promise<void> => {
  const loadPromises = namespaces.map((ns) => {
    if (!isTranslationLoaded(lng, ns)) {
      // This will trigger the individual namespace loading
      return new Promise<void>((resolve) => {
        i18n.loadNamespaces(ns, () => resolve());
      });
    }
    return Promise.resolve();
  });

  await Promise.all(loadPromises);
};

export default useTranslation;
